import axios from "axios";

const BASE_URL = `/m-1/sign`;

/**
 * Serwis do komunikacji z API - endpoint /sign
 */
export const SignService = {
  getTaskList,
  signResult
};

function getTaskList(docId, clientId) {
    return axios.post(`${BASE_URL}/getTaskList/${docId}/${clientId}`);
  }

function signResult(data) {
  return axios.post(`${BASE_URL}/signResult`, data);
}
